import { closeLoader, openLoader } from '@store/actions/LoaderAction';
import { Types } from '@store/types';

import ApiClient from '@lib/apiClient';

export const fetchMoodBoardDetails = (id) => async (dispatch) => {
	dispatch(openLoader());
	await ApiClient.GET('moodboardAction', id)
		.then((response) => {
			dispatch(closeLoader());
			dispatch({
				type: Types.FETCH_MOODBOARD_DETAILS,
				payload: response.data
			});
		})
		.catch((err) => {
			dispatch(closeLoader());
			return err;
		});
};
